// mobile nav. Guarded: a missing element here would throw and kill every
// script below it, including the hero readout.
const burger=document.querySelector('.burger'),navEl=document.getElementById('nav');
if(burger&&navEl){
  burger.addEventListener('click',()=>{
    const open=navEl.classList.toggle('open');
    burger.setAttribute('aria-expanded',open);
  });
}

// In-page navigation, done in JS. Native anchor jumps get blocked inside
// sandboxed preview frames, and this also clears the sticky header.
const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
document.addEventListener('click',e=>{
  const link=e.target.closest('a[href^="#"]');
  if(!link)return;
  const id=link.getAttribute('href').slice(1);
  if(!id){e.preventDefault();return;}          // bare "#" placeholders do nothing
  const target=document.getElementById(id);
  if(!target)return;
  e.preventDefault();
  if(navEl) navEl.classList.remove('open');
  if(burger) burger.setAttribute('aria-expanded','false');
  const top=id==='top'?0:target.getBoundingClientRect().top+window.scrollY-72;
  window.scrollTo({top,behavior:reduced?'auto':'smooth'});
  history.replaceState(null,'','#'+id);
  target.setAttribute('tabindex','-1');
  target.focus({preventScroll:true});
});


// Cart count refresh after an add-to-cart form posts back
document.addEventListener('DOMContentLoaded',()=>{
  const el=document.querySelector('[data-cart-count]');
  if(!el)return;
  fetch('/cart.js').then(r=>r.json()).then(c=>{el.textContent=c.item_count;}).catch(()=>{});
});

// Hero live readout. Drifts gently so it reads as a real meter rather than a
// fixed stat. Skipped entirely when the visitor prefers reduced motion.
document.addEventListener('DOMContentLoaded',()=>{
  const wEl=document.getElementById('live-w');
  const pEl=document.getElementById('live-p');   // optional, may not be present
  if(!wEl) return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  let watts=612, pence=114;
  setInterval(()=>{
    watts=Math.max(380,Math.min(790,watts+Math.round((Math.random()-0.48)*46)));
    wEl.textContent=watts+' W';
    if(pEl){
      if(Math.random()<0.5) pence+=1;
      pEl.textContent='£'+(pence/100).toFixed(2);
    }
  },1500);
});

// Add to basket without a page reload. Posts to Shopify's cart API, updates the
// count, and shows a brief confirmation. Falls back to a normal form submit if
// anything goes wrong, so the button always works.
document.addEventListener('DOMContentLoaded',()=>{
  const counts=document.querySelectorAll('[data-cart-count]');
  if(!counts.length) return;

  let toast;
  function confirmAdd(name){
    if(!toast){
      toast=document.createElement('div');
      toast.className='cart-toast';
      toast.setAttribute('role','status');
      toast.setAttribute('aria-live','polite');
      document.body.appendChild(toast);
    }
    toast.innerHTML='<span>Added: '+name+'</span>'
      +'<a href="/cart">View basket</a>'
      +'<a class="toast-go" href="/checkout">Checkout</a>';
    toast.classList.add('show');
    clearTimeout(toast._t);
    toast._t=setTimeout(()=>toast.classList.remove('show'),4200);
  }

  document.querySelectorAll('form[action*="/cart/add"]').forEach(form=>{
    form.addEventListener('submit',async e=>{
      const btn=(e.submitter&&e.submitter.tagName==='BUTTON')
        ? e.submitter
        : form.querySelector('button[type="submit"]');
      if(!window.fetch||!btn) return;              // let the browser do it
      e.preventDefault();
      const buyNow=btn.hasAttribute('data-buy-now');

      const label=btn.textContent.trim();
      btn.disabled=true; btn.textContent='Adding…';

      try{
        const res=await fetch('/cart/add.js',{
          method:'POST',
          headers:{'Accept':'application/json'},
          body:new FormData(form)
        });
        if(!res.ok) throw new Error('add failed');
        const item=await res.json();

        if(buyNow){
          btn.textContent='Going to checkout…';
          window.location.href='/checkout';
          return;
        }

        const cart=await (await fetch('/cart.js')).json();
        counts.forEach(el=>{el.textContent=cart.item_count;});
        confirmAdd(item.product_title||'item');
        btn.textContent='Added';
        setTimeout(()=>{btn.textContent=label; btn.disabled=false;},1600);
      }catch(err){
        form.submit();                              // fall back to a real submit
      }
    });
  });
});
